// extracted by mini-css-extract-plugin
module.exports = {"announcementIcon":"antd-pro-components-promotion-icon-styles-announcementIcon"};